export enum VariablesEnum {
  variables = 'variables',
  prompts = 'prompts',
}

export const VARIABLES_TAB_LABEL = 'Variables';
export const PROMPTS_TAB_LABEL = 'Prompts';

export const VARIABLES_TAB = { name: VariablesEnum.variables, label: VARIABLES_TAB_LABEL };
export const PROMPTS_TAB = { name: VariablesEnum.prompts, label: PROMPTS_TAB_LABEL };

export const promptLibraryVariables = [
  'agent_name',
  'RAG',
  'TodayDateTime',
  'SpeakLanguage',
  'PageHeaders',
  'PageSubHeaders',
  'PageUrl',
  'PageTitle',
  'ConversationChannel',
  'UserPhone',
  'InboundPhone',
  'OutboundPhone',
  'participant_info_metadata',
  'AvailableLanguagesSwitch',
  'ConferenceCallInfo',
  'presentationContent',
].sort();
